import { AutomationsPresentationV1Edge } from 'Automations/automationEditor/types'

/**
 * Keep the first copy of each connection and drop the rest. A connection is the
 * pair of handles it joins, so a second copy is the same connection stored
 * twice, not a second line on the canvas.
 *
 * Nothing shows one: the canvas draws a single line either way. The compiler
 * goes off the stored list though, and expands each copy into its own path, so
 * everything below runs twice.
 *
 *   stored:  START -> SWITCH    drawn:    one line
 *            START -> SWITCH    compiled: two of everything below SWITCH
 */
export const dedupeEdges = (
  edges: AutomationsPresentationV1Edge[]
): AutomationsPresentationV1Edge[] => {
  const seen = new Set<string>()

  return edges.filter(edge => {
    const key = connectionKey(edge)
    if (seen.has(key)) return false

    seen.add(key)
    return true
  })
}

// Two records for one connection can differ in id: `reconnectEdge` gives the
// rewired copy a freshly derived one. So compare the handles, which is what
// `addEdge` checks before it refuses a connection it already has.
const connectionKey = (edge: AutomationsPresentationV1Edge): string =>
  [
    edge.source,
    edge.sourceHandle ?? '',
    edge.target,
    edge.targetHandle ?? ''
  ].join('|')
